/* eslint-disable camelcase */
import Intercom, { shutdown } from '@intercom/messenger-js-sdk';
import type { User } from 'services/FirebaseService/auth';

const MS_PER_SECOND = 1000;

// Lifts the launcher above sticky footer action bars used across the app.
const INTERCOM_VERTICAL_PADDING = 100;

interface SyncIntercomParams {
  user: User | null;
  enabled: boolean;
}

let intercomStarted = false;

export const hasIntercomStarted = () => intercomStarted;

export const syncIntercom = ({
  user,
  enabled,
}: SyncIntercomParams): boolean => {
  const appId = import.meta.env.VITE_INTERCOM_APP_ID?.trim();

  if (!appId || appId === '') {
    // eslint-disable-next-line no-console
    console.warn(
      'Intercom app ID is not set. Intercom will not be initialized.',
      appId,
    );
    return false;
  }

  if (!enabled || !user) {
    if (window.Intercom) shutdown();
    intercomStarted = false;
    return false;
  }

  Intercom({
    app_id: appId,
    user_id: user.uid,
    name: user.displayName ?? '',
    email: user.email ?? '',
    created_at: Math.floor(
      new Date(user.metadata.creationTime ?? 0).getTime() / MS_PER_SECOND,
    ),
    vertical_padding: INTERCOM_VERTICAL_PADDING,
  });

  intercomStarted = true;
  return true;
};

export const initializeIntercom = (user: User) =>
  syncIntercom({ user, enabled: true });

export const shutdownIntercom = () =>
  syncIntercom({ user: null, enabled: false });
